import { ApiBuilderType } from 'modules/common/types';

export const remove = (builder: ApiBuilderType) =>
	builder.mutation<void, number>({
		query: (id) => ({
			url: `/user-messages/${id}`,
			method: 'DELETE',
		}),
	});
